import * as XLSX from 'xlsx';

export interface UserCredentials {
  organization: string;
  email: string;
  password: string;
}

/**
 * Build and download a one-row .xlsx (Organization / User Email / Password)
 * for a user's initial or reset password, per the admin-managed user
 * credential-handoff requirement — the password is shown exactly once, here,
 * and never persisted or displayed anywhere else in the app.
 */
export const downloadCredentialsExcel = ({ organization, email, password }: UserCredentials): void => {
  const worksheet = XLSX.utils.json_to_sheet([
    { Organization: organization, 'User Email': email, Password: password },
  ]);
  worksheet['!cols'] = [{ wch: 30 }, { wch: 30 }, { wch: 20 }];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Credentials');

  const safeEmail = email.replace(/[^a-zA-Z0-9._-]/g, '_');
  XLSX.writeFile(workbook, `${safeEmail}_credentials.xlsx`);
};
